import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export const CloseSolid = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 22", fill: "none" },
            React.createElement("path", { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z", fill: "currentColor" }))));
};
